import { Stats } from "@/types/api";
import { clientLogger } from "@/utils/clientLogger";

export async function sendAnalyticsEvent(statsBody: Stats) {
  try {
    await fetch(`/api/ui-event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(statsBody),
    });
  } catch (error) {
    clientLogger.error("Error sending  analytics event:", {
      error,
      statsBody,
    });
  }
}